import { createI18n } from 'vue-i18n'
import en from './locales/en'
import es from './locales/es'
import { getUiLang, onLanguageChange } from './resolveLanguage'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _i18n: any = null

/**
 * Factory — called by main.ts AFTER resolveLanguage() so getUiLang() is already set.
 * Do not import the return value at module evaluation time; call this function instead.
 */
export function createAppI18n() {
  _i18n = createI18n({
    legacy: false,
    locale: getUiLang(),
    fallbackLocale: 'en',
    messages: { en, es },
    missingWarn: false,
    fallbackWarn: false,
  })

  onLanguageChange((code) => {
    if (_i18n?.global?.locale?.value !== undefined) {
      _i18n.global.locale.value = code
    } else if (_i18n?.global) {
      _i18n.global.locale = code
    }
  })

  return _i18n
}

/** Translate a key outside of a component template (e.g. in TypeScript class methods). */
export function t(key: string): string {
  return _i18n?.global?.t(key) ?? key
}
